import { TOrderEntryColi } from '../types'

export default function getDefaultColi({
  defaultWeight = 1,
  defaultLength = 0,
  defaultWidth = 0,
  defaultHeight = 0,
}: {
  defaultWeight: number | null | undefined
  defaultLength?: number
  defaultWidth?: number
  defaultHeight?: number
}): TOrderEntryColi {
  return {
    weight: defaultWeight,
    width: defaultWidth,
    length: defaultLength,
    height: defaultHeight,
    volume: 0,
  }
}
